// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * Default max listeners for use with {@link EventEmitter.setMaxListeners} function
 * @internal
 */
export const _MAX_EVENT_LISTENERS = 50;
//# sourceMappingURL=constants.js.map